export const localStorage_ = {
    getItem(key) {
      if (typeof window === "undefined") return null;
      return localStorage.getItem(key);
    },
    setItem(key, value) {
      if (typeof window === "undefined") return;
      localStorage.setItem(key, value);
    },
    removeItem(key) {
      if (typeof window === "undefined") return;
      localStorage.removeItem(key);
    },
  };
  
  